import { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';

import { siderWidth } from '../../../constants/layout'
import OpenButton from '../../layouts/OpenButton';
import CloseButton from '../../layouts/CloseButton';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';

import { contentPadding } from '../../layouts/layoutHelper';
import ContraTbl from '../../tables/ContraTbl';
import React from 'react';
import { Button } from 'antd';
import { FilterProvider, useFilter } from '../../../context/FilterContext';
import { motion } from "framer-motion";
import MotionLayout from '../../general/framer-motion/MotionLayout';
import ContractTbl from '../../tables/ContractTbl';

import AccountSummaryTbl from '../../tables/AccountSummaryTbl';

import Property from '../../../constants/property'
import OthersTbl from '../../tables/OthersTbl';

const mapDesc:any = Property.accountSummaryType;


const Index = () => {
    //const siderWidth = '200px';//sider width

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [inputs, setInputs] = useState<any>({});

    const [currentContentKey, setCurrentContentKey] = useState<any>(null);
    const [currentSlide, setCurrentSlide] = useState<any>(0);
    const [displayAllSlide, setDisplayAllSlide] = useState<any>(false);
    const [displayOne, setDisplayOne] = useState<any>(false);

    const [slideTitle, setSlideTitle] = useState<any>("Account Summary");

    const carouselRef = useRef<any>(null);

    const scrollableDivRef = useRef<HTMLDivElement>(null);
    const [firstSlidePosition, setFirstSlidePosition] = useState<number | null>(null);

    const [manualInput, setManualInput] = useState<any>({});



    const handleSidebarToggle = () => {
        if(isSidebarCollapsed ==false){
            // alert("close tab")
            setDisplayOne(true)
            setTimeout(() => {
                setDisplayOne(false);
            }, 600);
        }
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    const optionRow = (label:string,value:string)=>{
        return {
            label:label,
            value:value
        }
    }


    useEffect(() => {
        if(!currentContentKey){
            setSlideTitle('Account Summary')
        }else{
           

            setSlideTitle(mapDesc[currentContentKey])
        }
    
    }, [currentContentKey]);

    const handleNextContent = (key:any)=>{
        setCurrentSlide(1)
        setCurrentContentKey(key);
        goToSlide(1);
        scrollToTop();

        //update filter slider
        setManualInput({ 'status': key });
    }

    const backToMainContent = ()=>{
        setCurrentSlide(0)
        setCurrentContentKey(null);
        goToSlide(0);
        scrollToTop(firstSlidePosition||0)//back to previous position

         //update filter slider
         setManualInput({ 'status': "account_summary" });
    }

    const goToSlide = (index:any) => {
        if (carouselRef.current) {
          carouselRef.current.goTo(index);
        }
    };
    const scrollToTop = (topPosition = 0) => {
        if (scrollableDivRef.current) {
            setFirstSlidePosition(scrollableDivRef.current.scrollTop);
            scrollableDivRef.current.scrollTop = topPosition;
        }
    };


    const renderFirstSlide = () => {
        if(currentContentKey != null) return <></>

        return <AccountSummaryTbl requestOnRender={true} handleClick={(id:any)=>handleNextContent(id)}/>
    };

    const renderSecondSlide = () => {
        // alert(currentContentKey) 
        switch (currentContentKey) {
           
            case 'due_for_forceselling':
                return <ContractTbl  requestOnRender={true} settlementType={"1"}/>;
            case 'due_for_settlement':
                return <ContractTbl  requestOnRender={true} settlementType={"2"}/>;
            case 'remaining_purchase_contracts':
                return <ContractTbl  requestOnRender={true} settlementType={"3"}/>;
            case 'sales_proceed_due':
                return <ContractTbl  requestOnRender={true} settlementType={"4"}/>;
            case 'remaining_sales_contracts':
                return <ContractTbl  requestOnRender={true} settlementType={"5"}/>;
            case 'contra_gains':
                return <ContraTbl  requestOnRender={true} type={"0"}/>;
            case 'contra_losses':
                return <ContraTbl  requestOnRender={true} type={"1"}/>;
            case 'others':
                return <OthersTbl  requestOnRender={true} />;
            default:
                return <div>No Data</div>;
        }
    };


    ///filter columns
    const filterColumns = [
        {
            type: "selectUser",
            singleMode:true,
        },
        // {
        //     type:"selectDateRangePicker"
        // } ,
        // {
        //     type:"selectDynamic",// dynamic select to change second select box options
        //     label1:"Type",
        //     id1:"type",//first select
        //     options1:[
        //         optionRow('All',''),
        //         optionRow('Purchase','purchase'),
        //         optionRow('Sales','sales')
        //     ],
        //     label2:"Status",//second select
        //     id2:"status",
        //     defaultOption2:[
        //         optionRow('All', ''),
        //         optionRow(mapDesc['account_summary'], 'account_summary'),
        //         optionRow(mapDesc['due_for_forceselling'], 'due_for_forceselling'),
        //         optionRow(mapDesc['due_for_settlement'], 'due_for_settlement'),
        //         optionRow(mapDesc['remaining_purchase_contracts'], 'remaining_purchase_contracts'),
        //         optionRow(mapDesc['sales_proceed_due'], 'sales_proceed_due'),
        //         optionRow(mapDesc['remaining_sales_contracts'], 'remaining_sales_contracts'),
        //     ],
        //     options2:{//option for first select box selected option
        //         "purchase":[ //first selected value
        //             optionRow('All',''),
        //             optionRow('Due For Force Selling', 'Due_For_Force_Selling'),
        //             optionRow('Due For Settlement', 'Due_For_Settlement'),
        //             optionRow('Remaining Purchase Contracts', 'Remaining_Purchase_Contracts'),
        //         ],
        //         "sales":[
        //             optionRow('All',''),
        //             optionRow('Sales Proceed Due', 'Sales_Proceed_Due'),
        //             optionRow('Remaining Sales Contracts', 'Remaining_Sales_Contracts'),
        //         ]
        //     },
        // },
    ]

    
    return (
        <MotionLayout>
            <FilterProvider>
                <div className={`pb-5 page-layout  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="side-bar" style={{
                        width: isSidebarCollapsed ? '0' : siderWidth
                    }}>
                        <CloseButton 
                            handleClick={handleSidebarToggle}
                        />
                        <div className='content' style={{width:siderWidth}}>
                            <div className='pt-3'></div>
                            <FilterInputBuilder 
                                loading={tableLoading}
                                columns={filterColumns} 
                                initSearchWhenReceived={[`accounts[]`]}  
                                onSearchSubmit={(inputs:any)=>{
                                    let currentAccNo = inputs['accounts[]'] || [];
                                    setInputs(inputs);

                                }}
                                manualInput={manualInput}
                            />
                        </div>
                    
                    </div>
                    <div  className="main-content "  
                        ref={scrollableDivRef}
                        style={{
                            marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                            paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                            overflow:"auto",
                            maxHeight:"83vh"
                        }}
                    >
                        <OpenButton 
                            isSidebarCollapsed={isSidebarCollapsed}
                            handleClick={handleSidebarToggle}
                        />
                        <div className={ contentPadding(isSidebarCollapsed)}>
                   
                            <SlideTitle title={slideTitle}/>
                            <SliderBox
                                currentSlide={currentSlide}
                            >
                                <div >
                                    {renderFirstSlide()}
                                   
                                </div>
                                <div >
                                    <Button onClick={()=>backToMainContent()}  type="link"><u><div className=''>Back</div></u></Button>
                                    {renderSecondSlide()}
                                </div>
                            </SliderBox>

                        </div>
                    </div>
                </div>
            </FilterProvider>
        </MotionLayout>
    );
};

export default Index;

const SlideTitle = ({ title}:any) => {
    const { filterParams } = useFilter();
    const [selectedAccNoTitle,setSelectedAccNoTitle] = useState<any>("");

    
    useEffect(() => {
        handleFilter(filterParams)
    }, [filterParams]);

    const handleFilter = (filterParams:any)=>{
        setSelectedAccNoTitle("");

        let selectedValues = filterParams['accounts_details[]'];
        if(selectedValues && selectedValues.length > 0){
            const titles = selectedValues.map((item: { title: any; }) => item.title).join(', ');
            setSelectedAccNoTitle(titles);
        }
    }


    return (
        <div className="main-title">{title} {selectedAccNoTitle && <>({selectedAccNoTitle})</>} </div>
    );
}

const SliderBox = ({ 
    children,
    currentSlide =0

}: any) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const totalSlides = React.Children.count(children);

    useEffect(() => {
        setCurrentIndex(currentSlide)
    }, [currentSlide]);
  
    const goToNextSlide = useCallback(() => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    }, [isTransitioning, totalSlides]);
  
    const goToPrevSlide = useCallback(() => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);
    }, [isTransitioning, totalSlides]);
  
    useEffect(() => {
      if (isTransitioning) {
        timeoutRef.current = setTimeout(() => {
          setIsTransitioning(false);
        }, 500); // Match this duration with your CSS transition duration
      }
  
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }, [isTransitioning]);
  
    return (
      <div className="slider">
        <div className="slider-inner" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {React.Children.map(children, (child, index) => (
            <div className="slider-item" key={index}>
              {child}
            </div>
          ))}
        </div>
        {/* <button className="slider-button prev" onClick={goToPrevSlide} disabled={isTransitioning}>
          Prev
        </button>
        <button className="slider-button next" onClick={goToNextSlide} disabled={isTransitioning}>
          Next
        </button> */}
      </div>
    );
  };